import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Transaction
// export const fetchTransaction = createAsyncThunk(
//   "transaction/fetchTransaction",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await api.get("/transaction/panel/Transaction");
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const fetchTransaction = createAsyncThunk(
  "transaction/fetchTransaction",
  async ({ page = 1, search = "", fetchAll = false }, { rejectWithValue, getState }) => {
    try {
      const { transaction } = getState();
      const { pageSize , cache} = transaction;

        const cacheKey = `${page}_${search}_${pageSize}_${fetchAll}`;

      // ✅ cache check
      if (cache[cacheKey]) {
        return {
          data: cache[cacheKey],
          page,
          search,
          pageSize,
          fromCache: true,
        };
      }



      let url = `/transaction/panel/Transaction`;

      if (!fetchAll) {
        url += `?page=${page}&page_size=${pageSize}`;
      } else {
        url += `?page=1&page_size=10000`; // huge number to get all users
      }

      if (search) {
        url += `&search=${search}`;
      }

      const response = await api.get(url);

      return {
        data: response.data,
        page,
        search,
        pageSize,
        fromCache: false,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);





// Add Transaction
export const addTransaction = createAsyncThunk(
  "transaction/addTransaction",
  async (newTransaction, { rejectWithValue }) => {
    try {
      const response = await api.post("/transaction/panel/Transaction", newTransaction);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Transaction
export const updateTransaction = createAsyncThunk(
  "transaction/updateTransaction",
  async (transactionData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/transaction/panel/Transaction", transactionData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Transaction Slice
const transactionSlice = createSlice({
  name: "transaction",
  initialState: {
    transactionList: { result: [], pagination: { total_pages: 1 } },
      search: "", // ✅ NEW
      currentPage: 1,
      pageSize: 10, // ✅ controlled here
      totalPages: 1,
      cache: {}, // store data per page

    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },

      setPage: (state, action) => {
      state.currentPage = action.payload;
    },

      setPageSize: (state, action) => { 
      state.pageSize = action.payload;
      state.currentPage = 1; 
      state.cache = {}; 
    },
  
      // ✅ ADD THIS
     clearCache: (state) => {
      state.cache = {};
      }

  },
  extraReducers: (builder) => {
    builder
      // Fetch Transaction
      .addCase(fetchTransaction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(fetchTransaction.fulfilled, (state, action) => {
       
        const { data, page, search, pageSize, fromCache } = action.payload;

         const cacheKey = `${page}_${search}_${pageSize}_${false}`;

        // ✅ Save in cache if not cached already
        if (!fromCache) {
          state.cache[cacheKey] = data;
        }
        state.transactionList = data;

         // ✅ Page handling
         state.currentPage = page;

      // ✅ IMPORTANT: Calculate total pages from count
        const totalCount = data?.pagination?.count || 0;
        state.totalPages = Math.ceil(totalCount / pageSize);

        state.search = search;
        state.pageSize = pageSize;
        state.status = "succeeded";

      })


      .addCase(fetchTransaction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Transaction
      .addCase(addTransaction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addTransaction.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addTransaction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Transaction
      .addCase(updateTransaction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateTransaction.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateTransaction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError ,  setPage, setPageSize , clearCache } = transactionSlice.actions;

export default transactionSlice.reducer;
